/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlASMPaginatedResponse
 */
export interface ControlASMPaginatedResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlASMPaginatedResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ControlASMPaginatedResponse
     */
    page_size: number;
    /**
     * 
     * @type {number}
     * @memberof ControlASMPaginatedResponse
     */
    count: number;
    /**
     * 
     * @type {Array<any>}
     * @memberof ControlASMPaginatedResponse
     */
    results: Array<any>;
}

/**
 * Check if a given object implements the ControlASMPaginatedResponse interface.
 */
export function instanceOfControlASMPaginatedResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlASMPaginatedResponseFromJSON(json: any): ControlASMPaginatedResponse {
    return ControlASMPaginatedResponseFromJSONTyped(json, false);
}

export function ControlASMPaginatedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlASMPaginatedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'page_size': json['page_size'],
        'count': json['count'],
        'results': json['results'],
    };
}

export function ControlASMPaginatedResponseToJSON(value?: ControlASMPaginatedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results,
    };
}

